import React from 'react';
import { Link } from 'react-router-dom';

export default function LoginPage() {
  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: wire up real authentication
  };

  return (
    <div className="auth-page">
      <div className="auth-card hud-frame">
        <h1>Login</h1>
        <p className="sub">{'// ACCESS_YOUR_ACCOUNT'}</p>

        <form onSubmit={handleSubmit}>
          <div className="auth-field">
            <label>Email</label>
            <input type="email" placeholder="you@example.com" required />
          </div>
          <div className="auth-field">
            <label>Password</label>
            <input type="password" placeholder="••••••••" required />
          </div>
          <button type="submit" className="auth-submit">[ LOGIN ]</button>
        </form>

        <p className="auth-switch">
          Don't have an account? <Link to="/signup">Sign up</Link>
        </p>
      </div>
    </div>
  );
}